import dayjs, { Dayjs } from 'dayjs';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(timezone);

// Generates the array of Dayjs objects that form the schedule timeline
// (ulimately displayed as e.g. 7:00 PM, 7:30 PM, 8:00 PM, 8:30 PM...)
// @TODO: this will need to be updated to accommodate the dropdowns
// in the designs that allow the user to select a particular day
// and time period's schedule and display it. Probably will need to
// allow for an argument to be passed to generate schedule times
// based on a start time other than "now".
// param: primaryTimezone should be in IANA format, as passed by CS
// param: hoursToDisplay defaults to 4-hr period
export const getScheduleTimes = (
  now: Dayjs,
  primaryTimezone: string,
  hoursToDisplay = 4
) => {
  const nowTz = dayjs.tz(now, primaryTimezone);
  const minutes = nowTz.minute(); // current minutes past the hour
  const numberOfTimesToGenerate = hoursToDisplay * 2; // each hour gets split into two half-hour segments
  const time1 =
    minutes >= 30
      ? dayjs.tz(now.minute(30), primaryTimezone)
      : dayjs.tz(now.minute(0), primaryTimezone); // start time should be last full half-hour
  const scheduleTimes = [time1];
  // generate schedule times for the remaining number of half-hour segments
  // (numberOfTimesToGenerate - 1) because we have already generated time1
  for (let index = 0; index < numberOfTimesToGenerate - 1; index++) {
    // add a half hour to previous time in array to get new time to add
    const newTime = scheduleTimes[index].add(30, 'minute');
    scheduleTimes.push(newTime);
  }

  return scheduleTimes;
};
